export default {
  WINDOW_SIZE: null,
  IS_IOS: false,
  IS_ANDROID: false,
  IS_MOBILE_ONLY: false,

  PROJECT: {},
  TRANSACTION: {},
  TRANSACTION_KEY: '',
  TRANSACTION_QUERY: {},
  COMMISSION: null,
  PAYMENT_TYPE: null,

  DIGITAL_SELLING_FILE: '',

  APPLE_PAY_SESSION: null,

  PROJECT_LOCALE: {},

  /* Источник платежа
   * Указывает на необходимость редиректа для ожидания проведения платежа
   *
   * { redirect: Boolean, origin: String }
   **/
  PAYMENT_ORIGIN: null,

  // Список крипто транзакций
  CRYPTO_TRANSACTION_LIST: [],
};
